import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import type {
  TGetPartnerBusinessDocumentUrlParams,
  TGetPartnerBusinessDocumentUrlResponse,
} from "./getPartnerBusinessDocumentUrl.schema";

export const getPartnerBusinessDocumentUrl = (axios: IAxiosInstance) => {
  return async (
    params: TGetPartnerBusinessDocumentUrlParams
  ): Promise<string> => {
    const { whiteLabelID, document_key } = params;
    const response = await axios.noRetry.get<
      IApiResponse<TGetPartnerBusinessDocumentUrlResponse>
    >(`/api/partners/${whiteLabelID}/business-documents/url`, {
      params: { document_key },
    });
    const resData = response.data;
    if (resData?.success && resData.data?.url) {
      return resData.data.url;
    }
    throw new Error("Something went wrong");
  };
};
